import { Box, styled } from 'decentraland-ui2'

const LayoutContainer = styled(Box)({
  paddingTop: '66px',
})

export { LayoutContainer }
